module.exports = __webpack_public_path__ + "img/choose-02.17f65df5.png";